import React from "react";
import "./NotFound.css";

function NotFound() {
  return (
    <div className="page-con-full">
      <h1>Page Not Fount</h1>
    </div>
  );
}
export default NotFound;
